import * as Yup from 'yup'

const getYupValidationSchema = values => {
    return Yup.object().shape({
        name: Yup.string()
            .trim()
            .required('Name is required!'),
        body: Yup.string()
            .trim()
            .required('Body is required!')
    })
}

export default function validate(values) {
    return values => {
        const validationSchema = getYupValidationSchema(values)

        try {
            validationSchema.validateSync(values, { abortEarly: false })

            return {}
        } catch (error) {
            return getErrorsFromValidationError(error)
        }
    }
}

function getErrorsFromValidationError(validationError) {
    const FIRST_ERROR = 0
    return validationError.inner.reduce((errors, error) => {
        let path = error.path
        return {
            ...errors,
            [path]: error.errors[FIRST_ERROR],
        }
    }, {})
}
